import type {
  CoreBookingProduct,
  CoreBookingProductsResponse,
  CoreLocale,
  ParameterID,
  UNSAFE_any,
} from '@flecto/types'

import { useQueryClient } from '../../../../../flecto-core/src'
import { api } from '../../../services/api'
import { getAllItemsWithForEach } from '../items/getAllItemsWithForEach'

/**
 * Get all booking products by ID.
 *
 * @endpoint GET /api/saas/me/bookings/{bookingId}/booking_products
 * @scope saas
 * @see https://flecto.dev/api-5169317
 */
export async function getAllBookingProducts(
  bookingId: ParameterID,
  forceLocale?: CoreLocale
): Promise<CoreBookingProduct[]> {
  const options = forceLocale
    ? { headers: { 'Accept-Language': forceLocale } }
    : undefined

  const resBookingProducts = await api.get<CoreBookingProductsResponse>(
    `/api/saas/me/bookings/${bookingId}/booking_products`,
    options
  )

  return resBookingProducts.data?.booking_product
}
